import axios from 'axios';

export const generateAxiosInstance = () => {
  // console.log("CHOOSE_FILE", process.env.REACT_APP_BACKEND_CHOOSE_FILE)
  const baseURL = process.env.REACT_APP_BACKEND_ADMIN_URL; // Your base URL
  const accessToken = localStorage.getItem('accessToken');
  return axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });
};